export default __webpack_public_path__ + "static/media/password_off.729ddb10.svg";